import Register from "../Components/User/Register"

const RegisterPage = () => {
    return (
        <>
            <header className="App-header">
                <Register></Register>
            </header>
        </>
    )
}

export default RegisterPage